<template>
    <custom-node>
        <template #icon>
            <svg-icon
                class="node-icon"
                :icon="IconEnvelope"
                color="#9cc186"
                is-custom-icon
            />
        </template>

        <template #content>
            <flex-container>
                <h2>E-mail versturen</h2>
                <span v-if="false" v-tooltip.info="'Lorem ipsum'">
                    <svg-icon
                        :icon="IconCircleInfo"
                        is-custom-icon
                    />
                </span>
            </flex-container>
            <p>{{ subject }}</p>
        </template>
    </custom-node>
</template>

<script setup lang="ts">
    import { FlexContainer, SvgIcon } from '@keyvue/one-ui';
    import { computed } from 'vue';
    import type { Node } from '@keyvue/one-api-client';
    import CustomNode from '@/flow/flow/components/graph/custom-types/CustomNode.vue';

    import IconEnvelope from '@keyvue/one-awesome-icons/icons/regular/envelope.svg?component';
    import IconCircleInfo from '@keyvue/one-awesome-icons/icons/regular/circle-info.svg?component';

    interface Props {
        data: Node
    }

    const props = defineProps<Props>();
    const subject = computed(() => {
        return props.data.options.data?.subject;
    });
</script>

<style scoped lang="scss">
.custom-node {
    &[selected="false"] {
        :deep(.custom-node__visual) {
            background-color: #9cc186;

            &:hover {
                background-color: #ED6E2D;

                .node-icon {
                    color: #ED6E2D;
                }
            }
        }
    }
}
</style>
